/*
 * As abas do topo das páginas Sobre e Diretrizes (Sobre, Diretrizes, Termos de Serviço, Política de Privacidade). Cada aba só existe
 * quando há conteúdo: as Diretrizes com o recurso ligado, Termos e
 * Privacidade com um endereço (do fof/terms ou do admin do tema). As outras
 * políticas do fof/terms entram depois, com o próprio nome. Entre Diretrizes
 * e Termos ficam as páginas do fof/pages que o admin acrescentou à área.
 * Uma página nunca aparece duas vezes: se a política aponta para uma página
 * que já é aba extra, vale a aba extra (o rótulo e a posição escolhidos).
 */
import app from 'flarum/forum/app';
import LinkButton from 'flarum/common/components/LinkButton';
import { forumBool, t } from '../../utils/settings';

/** Uma aba extra (atributo `canelaAboutPages` do fórum, já filtrado pela visibilidade). */

export function legalPages() {
  const pages = app.forum.attribute('canelaLegalPages');
  return Array.isArray(pages) ? pages.filter(page => page && typeof page.url === 'string' && page.url) : [];
}
export function aboutPages() {
  const pages = app.forum?.attribute('canelaAboutPages');
  return Array.isArray(pages) ? pages.filter(page => page && Number(page.id) > 0) : [];
}
export function findAboutPage(id) {
  return aboutPages().find(page => Number(page.id) === id);
}

/** A política (Termos, Privacidade…) que é a página `id` do fof/pages. */
export function findLegalPage(id) {
  return legalPages().find(page => Number(page.pageId) === id);
}
export function legalLabel(page) {
  return page.key === 'tos' ? t('community.legal.tos') : page.key === 'privacy' ? t('community.legal.privacy') : page.title || page.url;
}

/** O nome da aba ativa de uma página extra (cada uma tem o seu). */
export function aboutPageTab(id) {
  return `canela.about_page:${id}`;
}
export function aboutPageUrl(page) {
  return app.route('canela.about_page', {
    page: page.slug ? `${page.id}-${page.slug}` : String(page.id)
  });
}
export function guidelinesEnabled() {
  return forumBool('canelaGuidelinesEnabled', false);
}
function isActive(routeName, active) {
  return routeName === active || active === 'canela.guidelines' && routeName === 'canela.faq';
}
export default function AboutNav(active) {
  const tabs = [];
  const internal = (tab, href, label, icon) => m("li", {
    className: isActive(tab, active) ? 'active' : ''
  }, m(LinkButton, {
    href: href,
    active: isActive(tab, active),
    icon: icon || undefined
  }, label));
  if (forumBool('canelaAboutEnabled', true)) tabs.push(internal('canela.about', app.route('canela.about'), t('community.about.title')));
  if (guidelinesEnabled()) tabs.push(internal('canela.guidelines', app.route('canela.guidelines'), t('community.guidelines.title')));

  // As páginas do fof/pages que já viraram aba (a escolha feita no Canela
  // vale): uma política que aponta para uma delas não ganha outra aba.
  const shown = new Set();
  aboutPages().forEach(page => {
    shown.add(Number(page.id));
    tabs.push(internal(aboutPageTab(Number(page.id)), aboutPageUrl(page), page.label, page.icon));
  });

  // As políticas como abas podem sair no admin: ficam só as abas escolhidas.
  const legal = forumBool('canelaLegalTabs', true) ? legalPages() : [];
  legal.forEach(page => {
    const label = legalLabel(page);
    if (page.pageId && shown.has(Number(page.pageId))) return;
    if (page.pageId) shown.add(Number(page.pageId));

    // Uma página do fof/pages abre aqui dentro, com as mesmas abas e o layout
    // das Diretrizes (a área Sobre precisa estar ligada para a rota existir).
    if (page.pageId && forumBool('canelaAboutEnabled', true)) {
      const param = page.slug ? `${page.pageId}-${page.slug}` : String(page.pageId);
      tabs.push(internal(aboutPageTab(Number(page.pageId)), app.route('canela.about_page', {
        page: param
      }), label));
      return;
    }
    const external = /^https?:\/\//i.test(page.url);
    tabs.push(m("li", {
      className: `CanelaAbout-navLegal CanelaAbout-navLegal--${page.key}`
    }, m("a", Object.assign({
      href: page.url
    }, external ? {
      target: '_blank',
      rel: 'noopener'
    } : {}), label)));
  });

  // Uma aba sozinha não é navegação.
  if (tabs.length < 2) return null;
  return m("nav", {
    className: "CanelaAbout-nav"
  }, m("ul", null, tabs));
}
flarum.reg.add('ramon-canela', 'forum/features/community/AboutNav', AboutNav);